// extracted by mini-css-extract-plugin
module.exports = {"root":"soeezblog-slug_root__m95IX","mainContainer":"soeezblog-slug_mainContainer__yva1s","article":"soeezblog-slug_article__xk0NN","navLink":"soeezblog-slug_navLink__T_23T"};